export type NotificationCenterTab = 'unread' | 'all'

export const getDefaultNotificationTab = (unreadCount: number): NotificationCenterTab =>
  unreadCount > 0 ? 'unread' : 'all'
